import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Language, GenericValue } from 'hisng';
import { PersonProfile } from '../../../model/personprofile';
import { PersonProfileEntryValue } from '../../../model/personprofile-entry-value';
import { HisGenericValueService, HisBaseGlobalsService } from 'hisng';
import { PersonProfileEntry } from '../../../model/personprofile-entry';
import { RESEARCH_FIELD_HISKEY_ID, ABOUT_ME_HISKEY_ID, TEACHING_FIELD_HISKEY_ID } from '../../../model/constant';


@Component({
    selector: 'psv-personprofile-edit-basic-data',
    templateUrl: './personprofile-edit-basic-data.component.html',
})
export class PersonProfileEntryEditBasicDataComponent implements OnInit, OnChanges {
    readonly ABOUT_ME_HISKEY_ID = ABOUT_ME_HISKEY_ID;
    readonly RESEARCH_FIELD_HISKEY_ID = RESEARCH_FIELD_HISKEY_ID;
    readonly TEACHING_FIELD_HISKEY_ID = TEACHING_FIELD_HISKEY_ID;
    readonly INITIAL_ENTRY_TEXT = '<ul><li></li></ul>';

    researchFieldsObject: PersonProfileEntry = new PersonProfileEntry();
    teachingFieldsObject: PersonProfileEntry = new PersonProfileEntry();
    aboutMeObject: PersonProfileEntry = new PersonProfileEntry();

    showTeachingFields: boolean;
    showResearchFields: boolean;
    showAboutMe: boolean;
    @Input() personProfile: PersonProfile;
    @Input() defaultLanguage: Language;

    private allProfileEntryTypes: GenericValue[];
    constructor( private valueService: HisGenericValueService, private hisBaseGlobalsService: HisBaseGlobalsService ) {}

    ngOnInit(): void {
        console.log('personProfile on init =', this.personProfile);
        console.log('defaultLanguage on init =', this.defaultLanguage);
        this.valueService.getValueTypes( 'personProfileEntryValue' ).subscribe( response => {
            this.allProfileEntryTypes = response;
            // Alle drei Enträge müssen onInit vorhanden sein oder erzeugt werden,
            // damit beim sofortigen Speichern die Backend-Validierung funktioniert.
            this.aboutMeObject = this.findOrCreateProfileEntry(ABOUT_ME_HISKEY_ID);
            this.researchFieldsObject = this.findOrCreateProfileEntry(RESEARCH_FIELD_HISKEY_ID);
            this.teachingFieldsObject = this.findOrCreateProfileEntry(TEACHING_FIELD_HISKEY_ID);
            console.log('profileEntries after init =', this.personProfile.profileEntries);
        } );
        this.showTeachingFields = this.hisBaseGlobalsService.getDd('cs.psv.person.profile.teachingFields')?.hidden;
        this.showResearchFields = this.hisBaseGlobalsService.getDd('cs.psv.person.profile.researchFields')?.hidden;
        this.showAboutMe = this.hisBaseGlobalsService.getDd('cs.psv.person.profile.aboutMe')?.hidden;
    }

    private findOrCreateProfileEntry(entryValueHiskeyId: number): PersonProfileEntry {
        let entry = this.personProfile?.profileEntries?.find( (e) => e.personProfileEntryValue?.hiskeyId === entryValueHiskeyId );
        if ( !entry && this.allProfileEntryTypes) {
            let entryValue = this.allProfileEntryTypes.find(val => val.hiskeyId === entryValueHiskeyId);
            entry = new PersonProfileEntry();
            entry.personProfileEntryValue = entryValue;
            entry.language = new GenericValue(12);
            if ( entryValueHiskeyId !== ABOUT_ME_HISKEY_ID ) {
                entry.entrytext = this.INITIAL_ENTRY_TEXT;
            }
            this.personProfile.profileEntries = [...this.personProfile.profileEntries, entry];
        } else if( entry && entry.entrytext === null && entryValueHiskeyId !== ABOUT_ME_HISKEY_ID){
            entry.entrytext = this.INITIAL_ENTRY_TEXT;
        } else if ( !entry ) {
            entry = new PersonProfileEntry();
        }
        return entry;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes['personProfile']) {

            // Alle drei Enträge müssen ngOnChanges vorhanden sein oder erzeugt werden,
            // damit beim sofortigen Speichern die Backend-Validierung funktioniert.
            this.aboutMeObject = this.findOrCreateProfileEntry(ABOUT_ME_HISKEY_ID);
            this.researchFieldsObject = this.findOrCreateProfileEntry(RESEARCH_FIELD_HISKEY_ID);
            this.teachingFieldsObject = this.findOrCreateProfileEntry(TEACHING_FIELD_HISKEY_ID);
            console.log('profileEntries after ngOnChanges =', this.personProfile.profileEntries);
        }
    }

    translationLanguageChanged(newLanguage: Language, entry: PersonProfileEntry) {
        if(!newLanguage) {
            return;
        }

        if(!entry._foreigntext) {
            entry._foreigntext = {};
        }
        if(!entry._foreigntext[newLanguage.iso_639_1]) {
            entry._foreigntext[newLanguage.iso_639_1] = {};
            entry._foreigntext[newLanguage.iso_639_1].entrytext = this.INITIAL_ENTRY_TEXT;
        }
    }

}
